<template>
  <div>
    <PublicLayout>
      <header class="sub-header">
        <div class="container">
          <h1>產品責任保險</h1>
        </div>
      </header>
      <HeaderNav activeLink="insurance" />
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
             <h2 class="section-title text-primary text-center">
              公司已投保產品責任保險 消費安心 業者放心
            </h2>
          </div>
        </section>
        <section class="m-sec">
          <div class="container text-center">
            <img
              src="@/assets/public/images/insurance/insurance.jpg"
              class="w-50"
              alt
            />
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/SafetyHeaderNav";
export default {
  name: "InsuranceScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 767px) {
  .public-page
    .manufactoring-table
    th:not(.td-bg-middle-dark):not(.td-bg-dark) {
    width: 120px;
  }
}
</style>
